import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { ShopifyLinkedService } from 'app/model/linkedservice/shopify.linkedservice';
import { passwordOrAKVtoSecretBase, secretBaseToPasswordOrAKV } from 'app/model/adapters/linkedservices/azure-key-vault.util';
import { CONNECTOR_VERSION20, GlobalVariables } from 'app/services/globals';
import { driverVersions } from 'app/registries/consts/tabular-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(ShopifyLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            version: GlobalVariables.enableShopifyV2 ? '*' : undefined,
            typeProperties: {
                host: '*',
                accessToken: 'secret',
                useEncryptedEndpoints: GlobalVariables.enableShopifyV2 ? undefined : '*',
                useHostVerification: GlobalVariables.enableShopifyV2 ? undefined : '*',
                usePeerVerification: GlobalVariables.enableShopifyV2 ? undefined : '*',
                encryptedCredential: '*'
            }
        }
    }
})
export class ShopifyLinkedServiceAdapter extends LinkedServiceAdapter<ShopifyLinkedService> {
    protected modelConstructor(): new () => ShopifyLinkedService {
        return ShopifyLinkedService;
    }

    protected model(): IModel {
        return ShopifyLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: ShopifyLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.ShopifyLinkedService;
        properties.type = Metamodel.modelFor(ShopifyLinkedService).name;
        if (linkedService.version === driverVersions.v2) {
            properties.version = CONNECTOR_VERSION20;
        }
        properties.typeProperties = {
            host: linkedService.host,
            accessToken: passwordOrAKVtoSecretBase(linkedService.accessToken, this.context),
            useEncryptedEndpoints: linkedService.useEncryptedEndpoints,
            useHostVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.useHostVerification : undefined,
            usePeerVerification: linkedService.useEncryptedEndpoints !== false ? linkedService.usePeerVerification : undefined
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: ShopifyLinkedService): Promise<ShopifyLinkedService> {
        const properties = linkedServiceResource.properties as Model.ShopifyLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.ShopifyLinkedServiceTypeProperties = properties.typeProperties;
        if (GlobalVariables.enableShopifyV2 || properties.version) {
            linkedService.version = properties.version === CONNECTOR_VERSION20 ? driverVersions.v2 : driverVersions.v1;
        }
        linkedService.isLegacyConnector = GlobalVariables.enableShopifyV2 && linkedService.version !== driverVersions.v2;
        linkedService.host = typeProperties.host;
        linkedService.accessToken = secretBaseToPasswordOrAKV(typeProperties.accessToken, true, this.context);
        linkedService.useEncryptedEndpoints = typeProperties.useEncryptedEndpoints;
        linkedService.useHostVerification = typeProperties.useHostVerification;
        linkedService.usePeerVerification = typeProperties.usePeerVerification;

        return linkedService;
    }
}
